import Vue from 'vue';
Vue.directive('auth', {
  inserted: function (el, binding) { // 在被绑定的元素插入到dom中时
    const hasAuth = function (needAuths, allAuths) { //判断用户是否拥有权限的function
      if(!allAuths || !allAuths.length){return true}
      // implement 
      let flag = true;
      for(let i in needAuths){
        if(allAuths.indexOf(needAuths[i]) == '-1'){
          flag = false;
        }
      }
      return flag
    }
    const allAuths = window.localStorage.getItem('Auths')?JSON.parse(window.localStorage.getItem('Auths')):[]; // 用户拥有的权限列表
    if (!hasAuth(binding.value, allAuths)) { //binding.value 可以获得绑定指令时传入的参数
      el.style = "display:none"; //修改元素的可见状态
    }
  }
})



// WEBPACK FOOTER //
// ./src/directives/auth.js